import { Component, Input, OnInit } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { FilmService } from "../../services/film.service";
import { PersonService } from "../../services/person.service";
import { ContentService } from "../../services/content.service";
import { FilmModel } from '../../models/film';
import { PersonModel } from '../../models/person';
import { ContentModel } from "../../models/content";

@Component({
  moduleId: module.id,
  selector: 'site-listContent',
  templateUrl: './listContent.component.html',
  styleUrls: ['./listContent.component.css']
})

export class listContentComponent {
  @Input()
  routingLink: String;

  @Input()
  contentTitle: String;

  @Input()
  contentSubtitle: String;

  @Input()
  contentList: ContentModel[];
  
    public getContentPath(type: string): string{
      switch(type){
        case "Written Film Review":
          return "written-film-review";
        case "Video Film Review":
          return "video-film-review";
        case "Critical Essay":
          return "critical-essay";
        case "Theoretical Essay":
          return "theoretical-essay";
        case "Video Essay":
          return "video";
        case "News Article":
          return "content-news";
      }
      return null;
    }
}

export class ListContent implements OnInit {
  
  film: FilmModel;
  content: ContentModel;

  constructor(private filmService:FilmService, private personService:PersonService, private contentService:ContentService)
  {
  }

  ngOnInit(): void{
    this.getFilm(1).subscribe(r =>{
      this.film = r;
      this.film.releaseDate = new Date(this.film.releaseDate);
    });
    this.getContent(1).subscribe(r =>{
      this.content = r;
      this.content.publishDate = new Date(this.content.publishDate);
    });
    // console.log(this.content);
  }

  private getFilm(index: number): Observable<FilmModel>
  {
    return this.filmService.getFilm(index).map((v,i)=>v);
  }

  private getContent(index: number): Observable<ContentModel>
  {
    return this.contentService.getContent(index).map((v,i)=>v);
  }

}


// WEBPACK FOOTER //
// /home/ppeters/filmCritClient/src/app/components/listContent/listContent.component.ts